import { RobotLogo } from './RobotLogo'

interface AuthLoadingStateProps {
  label?: string
  compact?: boolean
}

export function AuthLoadingState({ label = 'Loading...', compact = false }: AuthLoadingStateProps) {
  const wrapperClassName = compact
    ? 'flex flex-col items-center justify-center gap-2 text-sm text-foreground/55'
    : 'flex h-full w-full flex-col items-center justify-center gap-4 bg-background'
  const iconClassName = compact ? 'h-10 w-10 animate-bounce' : 'h-14 w-14 animate-bounce'
  const labelClassName = compact ? 'text-center text-sm font-base text-foreground/60' : 'text-sm font-base text-foreground/60'

  return (
    <div className={wrapperClassName}>
      <RobotLogo className={iconClassName} animated withShadow />
      <div className="flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="block h-2 w-2 rounded-full border-2 border-nb-border bg-main"
            style={{ animation: `nb-blink 1.2s ${i * 0.2}s infinite` }}
          />
        ))}
      </div>
      <p className={labelClassName}>{label}</p>
    </div>
  )
}
